export function compareWeeks(date1: Date, date2: Date): boolean {
  const week1 = date1.getWeek();
  const week2 = date2.getWeek();

  const year1 = date1.getFullYear();
  const year2 = date2.getFullYear();

  return week1 === week2 && year1 === year2;
}
